module.exports = __webpack_public_path__ + "/static/assets/80ad76114d0b3f2fc54a3756dd283a53.svg";